import assert from 'assert';

import {TableEditableState} from 'notebook/tables/core-ui/TableEditableState';
import {TableModelContext} from 'notebook/tables/store/contexts/TableModelContext';
import {TableModel} from 'notebook/tables/store/models/TableModel';

export function useTableModel(): {
  tableModel: TableModel;
  setState: (state: Partial<TableEditableState>) => void;
};
export function useTableModel<T>(subSelector: (tableModel: TableModel) => T): {
  tableModel: T;
  setState: (state: Partial<TableEditableState>) => void;
};
export function useTableModel<T>(subSelector?: (tableModel: TableModel) => T): {
  tableModel: T;
  setState: (state: Partial<TableEditableState>) => void;
} {
  const {
    tableModelSelector: tableSelector,
    setState,
    useTableEditableStore: useStructuredTableStore,
  } = TableModelContext.useContext();

  const tableModel = useStructuredTableStore((store) => {
    const tableModel = tableSelector(store);
    assert(tableModel, 'TableModel must be initialized before useTable is called');
    if (!subSelector) {
      return tableModel as T;
    }
    return subSelector(tableModel);
  });

  return {
    tableModel,
    setState,
  };
}
